export interface ModelPart {
  name: string;
  path: string;
  icon: string;
}

export interface CharacterModel {
  name: string;
  path: string;
  icon: string;
  license: string;
  licenseUrl: string;
  sourceUrl: string;
  format: string;
  rig: string;
  animationCount: number;
  polygons: string;
  vertices: string;
  textures: string;
  materials: string;
  fileSize: string;
}

export const CAR_MODELS: ModelPart[] = [
  { name: 'Engine Block', path: '/models/engine-block.glb', icon: 'E' },
  { name: 'Wheel & Tire', path: '/models/wheel-tire.glb', icon: 'W' },
  { name: 'Sedan Body', path: '/models/sedan-body.glb', icon: 'S' },
  { name: 'Blender Export', path: '/models/blender-scene.glb', icon: 'B' },
];

export const CHARACTER_MODELS: CharacterModel[] = [
  {
    name: 'Robot Expressive',
    path: '/models/robot-expressive.glb',
    icon: 'R',
    license: 'CC0 1.0 Universal',
    licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
    sourceUrl: 'https://github.com/mrdoob/three.js/tree/dev/examples/models/gltf/RobotExpressive',
    format: 'glTF 2.0',
    rig: 'Yes',
    animationCount: 14,
    polygons: '3,237',
    vertices: '7,214',
    textures: '1',
    materials: '3',
    fileSize: '453 KB',
  },
  {
    name: 'Animated Fox',
    path: '/models/fox-animated.glb',
    icon: 'F',
    license: 'CC0 + CC BY 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by/4.0/',
    sourceUrl: 'https://github.com/KhronosGroup/glTF-Sample-Assets/tree/main/Models/Fox',
    format: 'glTF 2.0',
    rig: 'Yes',
    animationCount: 3,
    polygons: '576',
    vertices: '1,728',
    textures: '1',
    materials: '1',
    fileSize: '159 KB',
  },
  {
    name: 'Rigged Figure',
    path: '/models/rigged-figure.glb',
    icon: 'G',
    license: 'CC BY 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by/4.0/',
    sourceUrl: 'https://github.com/KhronosGroup/glTF-Sample-Assets/tree/main/Models/RiggedFigure',
    format: 'glTF 2.0',
    rig: 'Yes',
    animationCount: 1,
    polygons: '256',
    vertices: '370',
    textures: '1',
    materials: '1',
    fileSize: '49 KB',
  },
];

export const DEFAULT_CHARACTER_MODEL = CHARACTER_MODELS[0].path;

export const DEFAULT_MODEL = CAR_MODELS[0].path;
export const MODEL_COUNT = CAR_MODELS.length;

export const BLENDER_LAB_MODEL = '/models/student-character.glb?v=student-face-v9';
export const BASE_HEAD_STUDY_MODEL = '/models/base-head-study.glb?v=base-head-v2';
export const NEUTRAL_BASE_HEAD_MODEL = '/models/neutral-base-head.glb?v=neutral-base-v1';
export const GAME_BASE_HEAD_MODEL = '/models/game-base-head.glb?v=game-base-v95';
